export enum HighContrastTheme {
  none = "",
  dark = "dark",
  light = "light",
}
